import React, { useEffect, useMemo } from "react";
import { Modal } from "antd";

interface ErrorModalProps {
  visible: boolean;
  errorMessage: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  visible,
  errorMessage,
  onClose,
}) => {
  const [modal, contextHolder] = Modal.useModal();

  const config = useMemo(() => ({
    title: "Error!",
    content: errorMessage,
    onOk: onClose,
  }), [errorMessage, onClose]);

  useEffect(() => {
    if (visible) {
      modal.error(config);
    }
  }, [visible, modal, config]);

  return <>{contextHolder}</>;
};

export default ErrorModal;
